<template>
  <div class="flex items-baseline text-primary-50">
    <a href="/" class="u-center h-16 sm:h-15" aria-label="onedio logo" :title="logo.title" :style="logo.style">
      <OImage v-if="logo.isImage" loading="lazy" :src="logo.src" :style="logo.size" />
      <OIcon v-else icon="onedio" :svg-style="`width: ${isMobile ? '112px' : '94px'}; height: auto`" />
    </a>
  </div>
</template>

<script>
import { defineComponent, computed } from '@nuxtjs/composition-api';
import { useDevice } from '~/composables/useDevice';
import { OImage, OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OImage, OIcon },
  props: {
    dark: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { isMobile } = useDevice();
    const showDefault = true;
    const logo = computed(() => {
      if (showDefault) {
        return {
          isImage: false,
          title: 'Ana Sayfa',
        };
      }
      return {
        isImage: true,
        title: "Bolu'daki Yangın Faciası",
        src: `/images/afet-logo-${!isMobile.value || props.dark ? 'black' : 'white'}.png`,
        style: `width: ${isMobile.value ? '120px' : '120px'}; height: '28px'`,
        size: `width: ${isMobile.value ? '120px' : '120px'}; height: '28px'`,
      };
    });
    return { isMobile, logo };
  },
});
</script>

<style></style>
